// Adaptive terminology: an event selling ONE horse must never say
// "Lot" / "Catalogue" / "Collection". Chosen single-horse term:
// "Exclusive Offering" — elegant, value-transmitting, and semantically safe
// ("Private Offering/Sale" means an off-market sale OUTSIDE the auction in
// industry usage; "Exclusive Listing" is broker jargon).
// Swap the term in one place: the `term.single.*` keys in each locale file.
export const termKey = (single, key) => `term.${single ? "single" : "multi"}.${key}`;
